<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="getList"
      ></ly-search>
    </report-top>
    <selectTool ref="selectTool">
      <template slot="text">位置标注点列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </template>
    </selectTool>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectData = $event"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openUpdate(row)" type="primary"
          >编辑</Button
        >
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>

    <form-model
      @close="close"
      width="500"
      ref="formModel"
      title="开始创建"
      :overAuto="false"
      :labelWidth="80"
    >
      <template #suffix>
        <Button @click="autoGetAddress">地图获取</Button>
      </template>
      <Button slot="btn" type="primary" @click="addUpdate">提交</Button>
    </form-model>
  </div>
</template>
<script>
let devices = [],
  devicesGoal = [];
let typss = [
  {
    id: "COPY",
    name: "检索",
  },
  {
    id: "DELETE",
    name: "删除",
  },
];
export default {
  data() {
    let defaultItem = {
      sourceDeviceNo: "",
      targetDeviceNoList: [],
      enable: true,
      id: 0,
    };
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 40,
        },

        {
          title: "源设备",
          key: "sourceDeviceNo",
        },
        {
          title: "目标设备",
          key: "targetDeviceNoList",
          render: (h, data) => {
            return h("p", data.row.targetDeviceNoList.join(","));
          },
        },
        {
          title: "是否启用",
          key: "createTime",
          render: (h, data) => {
            let config = {
              true: {
                name: "是",
                color: "primary",
              },
              false: {
                name: "否",
                color: "gray",
              },
            };
            return h(
              "Tag",
              {
                props: {
                  color: config[data.row.enable].color,
                },
              },
              config[data.row.enable].name
            );
          },
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("p", this.utils.time(data.row.createTime));
          },
        },

        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      tableData: [],
      item: { ...defaultItem },
      defaultItem,
      forms: [
        {
          title: "源设备",
          key: "sourceDeviceNo",
          type: "Select",
          // multiple: true,
          required: true,
          selectType: "obj",
          selectItems: devices,
          span: 24,
        },
        {
          title: "目标设备",
          key: "targetDeviceNoList",
          type: "Select",
          multiple: true,
          required: true,
          selectType: "obj",
          selectItems: devices,
          span: 24,
        },
        {
          title: "是否启用",
          key: "enable",
          type: "bool",
          required: true,
          span: 24,
        },
      ],
      searchItem: { pageNumber: 1, pageSize: 20, keyword: "" },

      total: 0,
      selectData: [],
      time: null,
    };
  },
  methods: {
    getList() {
      // this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-customized-server-xzr/trackSync/selectPage",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.sourceEndTime = this.item.sourceEndTime + 86400 * 1000 - 1000;
      this.item.targetEndTime = this.item.targetEndTime + 86400 * 1000 - 1000;

      if (this.isAdd) {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-customized-server-xzr/trackSync/create",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();

            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-customized-server-xzr/trackSync/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-customized-server-xzr/trackSync/delete",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              if (this.outUse) {
                this.$emit("ok");
              } else {
                this.getList();
              }
            }
          });
        },
      });
    },
    //点击编辑按钮
    openUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      console.log(this.item);
      this.getDevice();
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.item = { ...this.defaultItem };
      this.isAdd = true;
      this.getDevice();
      //this.getDeviceGoal();

      this.$refs.formModel.reach(this.forms, this.item);
    },
    openDel() {
      this.item = { ...this.defaultItem };
      this.isAdd = true;
      this.getDevice();
      this.item.taskType = "DELETE";
      let forms = [
        {
          title: "设备",
          key: "sourceDeviceNo",
          type: "Select",
          multiple: false,
          required: true,
          selectType: "obj",
          selectItems: devices,
        },
        {
          title: "源开始时间",
          key: "sourceStartTime",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "源结束时间",
          key: "sourceEndTime",
          type: "lyyymmdd",
          required: true,
        },

        {
          title: "类型",
          key: "taskType",
          type: "Select",
          selectType: "obj",
          selectItems: typss,
          disabled: true,
        },
      ];
      this.$refs.formModel.reach(forms, this.item);
    },
    getDevice() {
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/getLocate",
        data: {
          returnCoord: 2,
        },
      }).then((res) => {
        this.$Spin.hide();
        let data = res.data.data;
        //data = data.filter((item) => item.active);

        devices.length = 0;
        for (let i = 0; i < data.length; i++) {
          var aaa = data[i].deviceUseType;
          data[i].name =
            aaa == null
              ? data[i].deviceNo
              : aaa == 1
              ? data[i].carNo + "[" + data[i].carTypeName + "]"
              : data[i].personName;
          let obj = {
            name: data[i].name,
            id: data[i].deviceNo,
            remark: data[i].deviceNo,
          };
          devices.push(obj);
        }
      });
    },
    getDeviceGoal() {
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/getLocate",
        data: {
          returnCoord: 2,
        },
      }).then((res) => {
        this.$Spin.hide();
        let data = res.data.data;

        devicesGoal.length = 0;
        for (let i = 0; i < data.length; i++) {
          var aaa = data[i].deviceUseType;
          data[i].name =
            aaa == null
              ? data[i].deviceNo
              : aaa == 1
              ? data[i].carNo + "[" + data[i].carTypeName + "]"
              : data[i].personName;
          let obj = {
            name: data[i].name,
            id: data[i].deviceNo,
            remark: data[i].deviceNo,
          };
          devicesGoal.push(obj);
        }
      });
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    drawCir(v) {
      this.$refs.point.drawCir(v);
    },
    autoGetAddress() {
      var ccc = this.$refs.point.getPoint();
      var pointList = [
        {
          x: ccc.x,
          y: ccc.y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.item.address =
          data[0].address == null ? "暂无地址" : data[0].address;
      });
    },
    close() {
      this.$refs.point.destroyMap();
    },
    fresh() {
      clearInterval(this.time);
      let t = 0;
      this.time = setInterval(() => {
        t++;
        if (t < 15) {
          this.getList();
        } else {
          clearInterval(this.time);
        }
      }, 1000);
    },
  },
  mounted() {
    //this.columns = this.utils.cols(this.forms, this.columns);
    this.getList();
  },
  computed: {
    radius() {
      return this.item.radius;
    },
  },
  watch: {
    radius(v) {
      setTimeout(() => {
        this.drawCir(v);
      }, 500);
    },
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/trackSync.vue